import { useState, type FormEvent } from 'react';
import { useLogin } from '@/lib/session';

/** Écran de connexion : gros champs, utilisable au doigt sur tablette ou téléphone. */
export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!username.trim() || !password) return;
    login.mutate({ username: username.trim(), password });
  }

  return (
    <main className="login-damier flex min-h-full items-center justify-center bg-[var(--brand-blue-dark)] p-6">
      <div className="w-full max-w-md space-y-6">
        <img
          src="/logo-small.png"
          alt="Super"
          className="mx-auto h-24 w-auto drop-shadow-lg"
          fetchPriority="high"
        />

        <form onSubmit={onSubmit} className="bg-card overflow-hidden rounded-xl shadow-[0_24px_48px_-12px_rgb(0_20_60/0.45)]">
          <div aria-hidden className="damier-strip" />
          <div className="space-y-6 p-6">
          <header className="text-center">
            <h1 className="page-title text-3xl">Reps</h1>
            <p className="text-muted-foreground mt-1 text-sm">Commandes chez le client</p>
          </header>

          <div className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="username" className="text-sm font-medium">
                Nom d'utilisateur
              </label>
              <input
                id="username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                autoComplete="username"
                spellCheck={false}
                required
                className="border-input bg-card focus:border-primary focus:ring-primary/15 h-14 w-full rounded-lg border px-4 text-lg focus:ring-4 focus:outline-none"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="password" className="text-sm font-medium">
                Mot de passe
              </label>
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                className="border-input bg-card focus:border-primary focus:ring-primary/15 h-14 w-full rounded-lg border px-4 text-lg focus:ring-4 focus:outline-none"
              />
            </div>
          </div>

          {login.isError && (
            <p role="alert" className="text-destructive text-center text-sm font-medium">
              {(login.error as Error).message}
            </p>
          )}

          <button
            type="submit"
            disabled={login.isPending}
            className="bg-primary text-primary-foreground hover:bg-primary-dark btn-caps h-14 w-full rounded-lg text-base transition-colors disabled:opacity-50"
          >
            {login.isPending ? 'Connexion…' : 'Se connecter'}
          </button>
          </div>
        </form>
      </div>
    </main>
  );
}
